module.exports = __webpack_public_path__ + "img/MV.6169b2cc.svg";